import './App.css'

import MyTasks from './components/MyTasks'

const App = () => <MyTasks />

export default App
